import { Component } from '@angular/core';

import { ICellEditorParams, JoinAdvancedFilterModel, NumberAdvancedFilterModel } from 'ag-grid-enterprise';

import { TextBoxComponent } from '@camelot/form-input';

import { BaseEditorComponent } from '../base-col';
import type { NumberCol } from './number-col';

@Component({
  host: { 'data-cid': 'number-editor' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [TextBoxComponent],
  template: ` @if (this.input) {
    <cam-input-textbox [input]="$any(this.input)" [standalone]="true" [onFocus]="this.focus$"></cam-input-textbox>
  }`,
})
export class NumberEditorComponent extends BaseEditorComponent<
  JoinAdvancedFilterModel | NumberAdvancedFilterModel,
  NumberCol
> {
  override agInit(params: ICellEditorParams) {
    super.agInit(params);
  }

  getValue() {
    return this.input?.value ?? null;
  }
}
